import React, { useContext, useState } from "react";

import LoginPage from "../../entities/LoginPage";
import AuthService from "../../api/AuthService";
import { useNavigate } from "react-router-dom";
import { useAlert } from "../../context/AlertContext";
import { ProfileContext } from "../../context/ProfileContext";
import { refreshDateFormat, setDateFormat } from "../../utils/dateFormatStore";

const Login = () => {
  const navigate = useNavigate();
  const { showAlert } = useAlert()
  const [profileState, updateProfileState] = useContext(ProfileContext)
  const [loading, setLoading] = useState(false);

  const handleSignIn = async (data) => {
    setLoading(true);

    try {
      const result = await AuthService.login(data);
      if (result?.success === true) {
        localStorage.setItem("accessToken", result?.data?.token);
        refreshDateFormat();
        // Employees cannot read company settings, so their login response carries the format.
        if (result?.data?.dateFormat) {
          setDateFormat(result.data.dateFormat);
        }
        localStorage.setItem("id", result?.data?.role === "Admin" ? result?.data?.companyId : result?.data?.companyId);
        localStorage.setItem("email", result.data.email ?? "");
        localStorage.setItem("role", result.data.role ?? "");
        localStorage.setItem("employeeId", result?.data?.role === "Employee" ? result?.data?.userId : result?.data?.userId ?? "");
        localStorage.setItem("companyId", result?.data?.companyId ?? "")
        if (result?.data?.userId || result?.data?.id || result?.data?._id) {
          localStorage.setItem("userId", result?.data?.userId || result?.data?.id || result?.data?._id || "");
        }
        localStorage.setItem("permission", JSON.stringify(result?.data?.permission ?? {}))
        localStorage.setItem(
          "countryPermissions",
          JSON.stringify(result?.data?.countryPermissions ?? {})
        );
        localStorage.setItem("is_subscription", result?.data?.is_subscription ?? false);
        localStorage.setItem("billing_info", result?.data?.billing_info ?? null);
        localStorage.setItem("isExpired", result?.data?.isExpired ?? false)
        localStorage.setItem("isTrialExpired", result?.data?.isTrialExpired ?? false)
        localStorage.setItem("isControlCenter", result?.data?.isControlCenter ?? false)
        // Verification flags. Default to `true` when the backend omits them so
        // pre-existing/legacy accounts are never locked out.
        const isEmailVerified = result?.data?.isEmailVerified ?? true;
        const isPhoneVerified = result?.data?.isPhoneVerified ?? true;
        localStorage.setItem("isEmailVerified", isEmailVerified)
        localStorage.setItem("isPhoneVerified", isPhoneVerified)
        showAlert(result?.message, "success")
        await updateProfileState([result?.data]);

        // Hard gate: an unverified email cannot reach the dashboard.
        if (isEmailVerified === false) {
          setLoading(false);
          navigate("/verify-email");
          return;
        }

        if (result?.data?.role === "Employee" && !result?.data?.permission) {
          try {
            const employeeId = result?.data?.userId || result?.data?.employeeId || localStorage.getItem("employeeId");
            if (employeeId) {
              const permissionResult = await AuthService.getEmployeePermission(employeeId);
              if (permissionResult?.success && permissionResult?.data) {
                localStorage.setItem("permission", JSON.stringify(permissionResult?.data));
              }
            }
          } catch (error) {
            console.error("Error fetching permissions:", error);
          }
        }

        if (result?.data?.role === "Admin") {
          const companyResult = await AuthService.getCompantList();
          setLoading(false);
          if (companyResult?.success && companyResult?.data?.[0]?.companyName) {
            navigate("/dashboard");
          } else {
            navigate("/companyInfo");
          }
        } else {
          setLoading(false);
          navigate("/dashboard");
        }
      } else {
        showAlert(result?.message, "error")
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  }
  return (
    <LoginPage handleSignIn={handleSignIn} loading={loading} />
  )

}

export default Login;
